'use strict';

import './components/tt-app/tt-app';
// optimization -> chrome warns otherwise
import {setPassiveTouchGestures} from '@polymer/polymer/lib/utils/settings'
import sw from './sw-loader';

setPassiveTouchGestures(true);

// service worker
sw()
    .then(reg => {})
    .catch((e) => {
        console.info('SW registration failed', e);
    });
